"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerContext = void 0;
var _react = _interopRequireDefault(require("react"));
const loggerContext = exports.loggerContext = /*#__PURE__*/_react.default.createContext(null);
//# sourceMappingURL=loggerContext.js.map